import { PortableTextBlock } from "sanity";
import classNames from "classnames";
import React from "react";
import RichText, { replaceOldStreamingProviderLinks, splitBlocksForAds, stripEmptyParagraphs } from "src/components/richtext/Richtext";
import styles from "./MainText.module.css";


//#region [Props]
type MainTextProps = {
  className?: string;
  mainText?: PortableTextBlock[];
  includeAds?: boolean;
  children?: React.ReactNode;
};
//#endregion

//#region [Component]
export default function MainText({ className, mainText, includeAds, children }: MainTextProps) {
  if ((mainText?.length ?? 0) === 0) {
    return null;
  }
  let _transformedMainText = stripEmptyParagraphs(mainText!);
  _transformedMainText = replaceOldStreamingProviderLinks(_transformedMainText);

  let _mainText = [_transformedMainText];
  let childrenArray: ReturnType<typeof React.Children.toArray> | undefined;

  if (includeAds && children && React.Children.count(children) > 0) {
    _mainText = splitBlocksForAds(_transformedMainText);
    if (_mainText.length > 1) {
      childrenArray = React.Children.toArray(children);
    }
  }

  return (
    <div className={classNames(styles.SBodyTextContainer, className)}>
      {_mainText.map((chunk, idx) => (
        <React.Fragment key={idx}>
          {idx > 0 && (childrenArray?.[idx - 1] ?? null)}
          <RichText className={styles.SBodyText} value={chunk} />
        </React.Fragment>
      ))}
    </div>
  );
}
//#endregion
